// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as Country$OrcaPaymentPage from "../Country.bs.js";
import * as HyperLogger$OrcaPaymentPage from "../hyper-log-catcher/HyperLogger.bs.js";
import * as CountryStateDataRefs$OrcaPaymentPage from "../CountryStateDataRefs.bs.js";

function decodeCountryArray(data) {
  return data.map(function (item) {
              var res = Core__JSON.Decode.object(item);
              if (res !== undefined) {
                return {
                        timeZones: Utils$OrcaPaymentPage.getStrArray(res, "timeZones"),
                        countryName: Utils$OrcaPaymentPage.getString(res, "value", ""),
                        isoAlpha2: Utils$OrcaPaymentPage.getString(res, "isoAlpha2", "")
                      };
              } else {
                return Country$OrcaPaymentPage.defaultTimeZone;
              }
            });
}

function decodeJsonTocountryStateData(jsonData) {
  var res = Core__JSON.Decode.object(jsonData);
  if (res === undefined) {
    return ;
  }
  var countryArr = Utils$OrcaPaymentPage.getArray(res, "country");
  var statesDict = Utils$OrcaPaymentPage.getJsonFromDict(res, "states", null);
  return {
          countries: decodeCountryArray(countryArr),
          states: statesDict
        };
}

function getNormalizedLocale(locale) {
  switch (locale) {
    case "" :
        return "en";
    case "auto" :
        return window.navigator.language;
    default:
      return locale;
  }
}

function fetchCountryStateFromS3(endpoint) {
  var headers = Object.fromEntries([[
          "Accept-Encoding",
          "br, gzip"
        ]]);
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(endpoint, undefined, headers, "GET", undefined, undefined, undefined).then(function (resp) {
                    return resp.json();
                  }).then(function (data) {
                  var val = decodeJsonTocountryStateData(data);
                  if (val !== undefined) {
                    return Promise.resolve(val);
                  } else {
                    return Promise.reject(Caml_js_exceptions.internalToOCamlException("Failed to decode country state data"));
                  }
                }), (function (param) {
                return Promise.reject(Caml_js_exceptions.internalToOCamlException("Failed to fetch country state data"));
              }));
}

var getBaseUrl = isLocal ? "" : sdkUrl;

async function getCountryStateData(localeOpt, loggerOpt) {
  var locale = localeOpt !== undefined ? localeOpt : "en";
  var logger = loggerOpt !== undefined ? loggerOpt : HyperLogger$OrcaPaymentPage.make(undefined, {
          TAG: "Elements",
          _0: "Payment"
        }, undefined, undefined, undefined);
  var normalizedLocale = getNormalizedLocale(locale);
  var timestamp = Date.now().toString();
  var endpoint = getBaseUrl + "/assets/v1/jsons/location/" + normalizedLocale + "?v=" + timestamp;
  try {
    return await fetchCountryStateFromS3(endpoint);
  }
  catch (exn){
    try {
      return await fetchCountryStateFromS3(getBaseUrl + "/assets/v1/jsons/location/en?v=" + timestamp);
    }
    catch (exn$1){
      logger.setLogError("Failed to fetch country state data", "S3_API", undefined, undefined, "ERROR", "USER_ERROR", undefined);
      try {
        var fallbackStates = await import("./../States.json");
        return {
                countries: Country$OrcaPaymentPage.country,
                states: fallbackStates.states
              };
      }
      catch (exn$2){
        return {
                countries: Country$OrcaPaymentPage.country,
                states: null
              };
      }
    }
  }
}

async function initializeCountryData(localeOpt, loggerOpt) {
  var locale = localeOpt !== undefined ? localeOpt : "en";
  var logger = loggerOpt !== undefined ? loggerOpt : HyperLogger$OrcaPaymentPage.make(undefined, {
          TAG: "Elements",
          _0: "Payment"
        }, undefined, undefined, undefined);
  try {
    var data = await getCountryStateData(locale, logger);
    CountryStateDataRefs$OrcaPaymentPage.countryDataRef.contents = data.countries;
    CountryStateDataRefs$OrcaPaymentPage.stateDataRef.contents = data.states;
    return data;
  }
  catch (exn){
    return {
            countries: Country$OrcaPaymentPage.country,
            states: null
          };
  }
}

export {
  decodeCountryArray ,
  decodeJsonTocountryStateData ,
  getNormalizedLocale ,
  fetchCountryStateFromS3 ,
  getBaseUrl ,
  getCountryStateData ,
  initializeCountryData ,
}
/* getBaseUrl Not a pure module */
